import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { getEmailTemplate, type EmailTemplateId } from "../../lib/email-templates.js";
import { authenticatedRoute } from "../_authenticated.js";

export interface EmailComposeSearch {
  to?: string;
  subject?: string;
  template?: EmailTemplateId;
  firstName?: string;
  companyName?: string;
}

export const emailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/email",
  validateSearch: (search): EmailComposeSearch => ({
    to: stringSearchValue(search["to"]),
    subject: stringSearchValue(search["subject"]),
    template: emailTemplateSearchValue(search["template"]),
    firstName: stringSearchValue(search["firstName"]),
    companyName: stringSearchValue(search["companyName"]),
  }),
  component: lazyRouteComponent(() => import("./email.page.js"), "TrackedEmailPage"),
});

function stringSearchValue(value: unknown) {
  return typeof value === "string" && value.trim() ? value : undefined;
}

function emailTemplateSearchValue(value: unknown): EmailTemplateId | undefined {
  if (typeof value !== "string") return undefined;
  const template = getEmailTemplate(value);
  return template?.id;
}
